export default class AgendamentoCompromisso {
    public descricao: string;

    constructor() {
      this.descricao = '';
    }
}
